<template>
  <v-container fluid class="pa-0 ma-0">
    <loading v-if="isLoading" />

    <!-- Snackbar de notificação -->
    <v-snackbar v-model="showResult" :timeout="3000" :color="color" top right>
      <v-icon left>{{ color === 'red' ? 'mdi-alert-circle' : 'mdi-check-circle' }}</v-icon>
      {{ result }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showResult = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Card principal -->
    <v-card class="elevation-3 rounded-lg">
      <Tabela :headers="headers" :desserts="funcionarios" :title="titulo" :icon="icone" @search="initialize">
        <!-- Foto -->
        <!-- <template v-slot:item.photo="{ item }">
          <v-avatar size="40" class="elevation-1">
            <v-img :src="getPhoto(item)" alt="Avatar" class="avatar-img">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon>mdi-account</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </template> -->

        <template #item-action="{ item }">
          <v-menu offset-y left transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="grey" class="action-btn" small>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="editItem(item)">
                <v-list-item-icon>
                  <v-icon color="green">mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Editar Dados</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="showFileChooser(item)">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-camera</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Alterar Foto</v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </template>
      </Tabela>
    </v-card>

    <!-- Diálogo de edição -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-icon left>{{ formTitleIcon }}</v-icon>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="editedItem.nome" label="Nome completo" :rules="obrigqtorioRules" outlined
                  prepend-inner-icon="mdi-account" dense></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editedItem.bilhete" :label="descricao" :rules="ruleBI" v-mask="mascara" outlined
                  prepend-inner-icon="mdi-card-account-details" dense></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editedItem.telefone" label="Telefone" :rules="obrigqtorioRules" outlined
                  prepend-inner-icon="mdi-phone" dense></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="d-flex align-center">
                <v-switch v-model="outroDocumento" @change="outroDoc()"
                  :label="`Usar ${descricao === 'Bilhete' ? 'outro documento' : 'bilhete'}`" class="mt-0 ml-2"
                  hide-details></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="close" color="grey darken-1">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="save" :loading="overlay">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Input oculto para upload de foto -->
    <input type="file" ref="input" @change="setImage" accept="image/*" style="display: none">

    <!-- Componente de carregar foto -->
    <carregarFoto :usuario="editedItem" :eventPhoto="eventPhoto" @fecharComponente="fecharTelaComponente"
      v-if="menuSelected === 1"></carregarFoto>
  </v-container>
</template>

<script>
import Tabela from "../componentes/configuracoes/Tabela.vue";
import axios from "../../../plugins/axios";
import carregarFoto from "../componentes/usuario/carregarfoto.vue";
import photoUser from "../../../utilitarios/photo.services";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
const ls = require("local-storage");
import loading from "../../../components/loading.vue";
export default {
  components: {
    Tabela,
    carregarFoto,
    loading
  },
  directives: { mask },
  data: () => ({
    titulo: "Funcionários",
    icone: "mdi-account-tie",
    eventPhoto: null,
    menuSelected: 0,
    dialogoUpload: false,
    imgSrc: "",
    text: "",
    overlay: false,
    showResult: false,
    color: "",
    result: "",
    flag_curso: "",
    formValid: true,
    progresso: false,
    mascara: "#########-AA-###",
    usuarios: [],
    isLoading: false,
    search: "",
    descricao: "Bilhete",
    cursos: [],
    usuariosJaExistentes: [],
    obrigqtorioRules: [(value) => !!value || "campo obrigatório."],
    ruleEmailRequired: [
      (value) => value.length <= 50 || "O máximo número de carácters atigidos",
      (value) => !!value || "campo obrigatório.",
      (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],
    ruleBI: [
      (value) => value.length === 16 || "Minimo de caracteres exigido( 16 ).",
    ],
    funcionarios: [],
    dialog: false,
    headers: [
      { text: '#', value: 'index', width: '50px', align: 'center' },
      // { text: "Foto", value: "photo" },
      {
        text: "Nome",
        align: "left",
        sortable: false,
        value: "nome",
      },
      { text: "B.I", value: "bilhete" },
      { text: "Telefone", value: "telefone" },
      { text: "Data de cadastro", value: "data_2" },
      { text: "Actions", value: "action", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      idFuncionario: "",
      idPEssoa: "", // bi
      i_id: "", // idinstituicao
      email: "",
      nome: "",
      telefone: "",
      bilhete: "",
    },
    defaultItem: {
      idFuncionario: "",
      idPEssoa: "", // bi
      i_id: "", // idinstituicao
      email: "",
      nome: "",
      telefone: "",
      bilhete: "-",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Novo Funcionário" : "Editar";
    },
    ListaActividades() {
      return ls.get("lista_actividades");
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    getPhoto(item) {
      try {
        return photoUser.getPhotoUser(item.idPEssoa);
      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro ao carregar a foto", "error");
      }
    },
    async initialize(search) {
      try {
        this.overlay = true;
        if (!search) {
          var payload = '{"find":"all"}';
        } else {
          var payload = '{"find":"' + search + '"}';
        }

        this.funcionarios = await axios
          .get("/funcionarioFindAll/" + payload)
          .then((res) => res.data)
          .then(this.CarregaUsuarios());
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorru um erro durante o carregamento da página",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    editItem(item) {
      this.editedIndex = this.funcionarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async CarregaUsuarios(search) {
      try {
        this.overlay = true;
        if (!search) {
          var payload = '{"find":"all"}';
        } else {
          var payload = '{"find":"' + search + '"}';
        }
        this.usuarios = await axios
          .get("/usuarioFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Erro",
          "Ocorru um erro durante o carregamento da página",
          "error"
        );
      } finally {
        this.overlay = false;
      }
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        try {
          let params = {
            idFuncionario: this.editedItem.idFuncionario,
            nome: this.editedItem.nome,
            idPEssoa: this.editedItem.bilhete,
            email: this.editedItem.email,
            telefone: this.editedItem.telefone,
            instituicao_descricao: ls.get("instituicaodescricao"),
          };

          let funcionariojaexiste = this.funcionarios.filter(
            (f) =>
              (f.idFuncionario !== this.editedItem.idFuncionario &&
                f.idPEssoa === this.editedItem.bilhete) ||
              (f.idFuncionario !== this.editedItem.idFuncionario &&
                f.bilhete === this.editedItem.bilhete)
          );
          if (!funcionariojaexiste.length) {
            try {
              let msg = await axios
                .post("/funcionarioInsertOrUpdate", params)
                .then((res) => res.data);

              // verificação da mensagem
              if (msg.length) {
                Swal.fire(
                  "Erro",
                  "Ocorru um erro durante ao editar do funcionário",
                  "error"
                );
              } else {
                Swal.fire(
                  "Sucesso",
                  "Informações editadas com sucesso!",
                  "success"
                );
                this.dialog = false;
                this.initialize();
              }
            } catch (error) {
              Swal.fire(
                "Erro",
                "Ocorru um erro durante ao editar o funcionário",
                "error"
              );
            }
          } else {
            this.showResult = true;
            this.result = "Número de bilhete ou email já usado!";
            this.color = "red";
          }
        } catch (error) {
          Swal.fire(
            "Erro",
            "Ocorru um erro durante ao editar o funcionário",
            "error"
          );
        } finally {
          this.overlay = false;
        }
      } else {
        this.showResult = true;
        this.result = "Preencha os campos vázios!";
        this.color = "red";
      }
    },

    close() {
      this.dialog = false;
    },

    outroDoc() {
      if (this.descricao === "Bilhete") {
        this.editedItem.bilhete = "";
        this.descricao = "Outro Doc.";
        this.mascara = "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
        this.ruleBI = [
          (value) =>
            (value.length >= 16 && value.length <= 30) ||
            "Minimo de caracteres exigido( 16 )",
        ];
      } else {
        this.editedItem.bilhete = "";
        this.descricao = "Bilhete";
        this.mascara = "#########-AA-###";
        ruleBI: [
          (value) =>
            value.length === 16 || "Minimo de caracteres exigido( 16 ).",
        ];
      }
    },
    fecharTelaComponente() {
      this.menuSelected = 0;
      this.initialize();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        Swal.fire({
          icon: "warning",
          title: "",
          text: "Por favor selecione uma imagem",
        });
      } else {
        if (typeof FileReader === "function") {
          this.eventPhoto = e;
          this.menuSelected = 1;
        } else {
          Swal.fire({
            icon: "warning",
            title: "",
            text: "Ficheiro não suportado",
          });
        }
      }
    },
    showFileChooser(item) {
      this.editedItem = { idPessoa: item.idPEssoa };
      this.$refs.input.click();
    },
  },
};
</script>

<style scoped>
/* Layout principal */
.v-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Tabela zebrada */
.striped-table>>>tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.striped-table>>>tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* Avatar */
.avatar-img {
  object-fit: cover;
  transition: transform 0.3s ease;
}

.avatar-img:hover {
  transform: scale(1.1);
  cursor: pointer;
}

/* Barra de pesquisa */
.search-field {
  max-width: 300px;
}

/* Ajustes para mobile */
@media (max-width: 960px) {
  .v-card__title {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 16px;
  }

  .search-field {
    margin-top: 12px;
    width: 100%;
    max-width: 100%;
  }

  .headline {
    font-size: 1.25rem;
  }
}

@media (max-width: 600px) {

  .v-data-table>>>th,
  .v-data-table>>>td {
    padding: 8px 4px !important;
    font-size: 0.8rem;
  }

  .v-data-table>>>th {
    font-size: 0.75rem !important;
  }

  .v-btn--icon.v-size--small {
    width: 28px;
    height: 28px;
  }

  .v-card__title {
    padding: 12px;
  }

  .v-card__text {
    padding: 8px;
  }
}

/* Efeitos de transição */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>